import React from 'react';
import { MicrophoneIcon } from '@heroicons/react/24/outline';
import { MicrophoneIcon as MicrophoneSolidIcon } from '@heroicons/react/24/solid';
import { useVoiceModeStore } from '@/store/voiceModeStore';

const ChatCommandBar: React.FC = () => {
  const voiceModeEnabled = useVoiceModeStore((s) => s.voiceModeEnabled);
  const toggleVoiceMode = useVoiceModeStore((s) => s.toggleVoiceMode);
  const isRecording = useVoiceModeStore((s) => s.isRecording);

  return (
    <div className="flex items-center gap-2 pl-8">
      <button
        onClick={toggleVoiceMode}
        className={`relative p-1.5 rounded-lg transition-all ${
          voiceModeEnabled
            ? 'bg-[var(--brand-accent-primary)] text-white shadow-sm'
            : 'text-[var(--brand-text-tertiary)] hover:text-[var(--brand-text-secondary)] hover:bg-[var(--brand-surface-hover)]'
        }`}
        title={voiceModeEnabled ? 'Disable voice mode' : 'Enable voice mode'}
      >
        {voiceModeEnabled ? (
          <MicrophoneSolidIcon className="w-4 h-4" />
        ) : (
          <MicrophoneIcon className="w-4 h-4" />
        )}
        {isRecording && (
          <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-red-500 animate-pulse" />
        )}
      </button>
    </div>
  );
};

export default ChatCommandBar;
